import InternalStaticAnchorBattles from 'models/application/anchor/types/internalStatic/types/Battles';

export default class InternalStaticAnchorBattlesService {
	toModel() {
		return new InternalStaticAnchorBattles();
	}
}
